/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/


import ProtectedRoute from "components/ProtectedRoute"; // Import your ProtectedRoute component
import Auth from "layouts/auth";


import LandingPage from "layouts/pages/LandingPage";
import OrganizationOverview from "layouts/pages/OrganizationOverview";
import ExampleLayout from "layouts/pages/ExampleLayout"

import OrganizationUsers from "components/OrganizationUsers"
import Billing_dashboard from "layouts/pages/Billing_dashboard";
import LineAxisIcon from '@mui/icons-material/LineAxis';
import ChartGenerator from "layouts/pages/ChartGenerator";
import SoundLevelMeter from "layouts/pages/SoundLevelMeter";
import ListAltSharpIcon from '@mui/icons-material/ListAltSharp';
import Contact from "layouts/pages/Contact";
import { Navigate } from "react-router-dom";


interface Route {
  type?: "collapse" | "title" | "divider";
  name?: string;
  key: string;
  route?: string;
  component?: React.ReactNode;
  icon?: React.ReactNode;
  collapse?: Route[];
  href?: string;
  title?: string;
  noCollapse?: boolean;
  hideInSidenav?: boolean;
}


const routes = [
  { name: "Contact", key: "Contact", route: "/Contact", component: <Contact />, hideInSidenav: true, },
    { type: "title", title: "Noise Monitors", key: "tite-noise-monitors" },

  { name: "Example Layout", key: "ExampleLayout", route: "/locations/:locationID", component: <ExampleLayout />, hideInSidenav: true, },
  { name: "Sign In", key: "auth", route: "/auth", component: <Auth />, hideInSidenav: true, },
  { name: "SLM", key: "slm", route: "/slm", component: <SoundLevelMeter />, hideInSidenav: true, },
  {
    type: "collapse",
    name: "Overview",
    key: "overview",
    route: "/OrganizationOverview",
    component: (
        <ProtectedRoute>
          <OrganizationOverview/>
        </ProtectedRoute>
    ),
    icon: <i className="material-icons">public</i>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Locations",
    key: "Locations",
    icon: <i className="material-icons">location_searching</i>,
    collapse: [
      { type: "divider", key: "divider-0" },
    ],
  },
  { type: "collapse",
    name: "Reports",
    key: "Reports",
    icon: <ListAltSharpIcon />,
    route: "/Reports",
    component: (
        <ProtectedRoute>
          <ChartGenerator />
        </ProtectedRoute>
        ), noCollapse: true},
  { type: "divider", key: "divider-0" },

  { type: "title", title: "SETTINGS", key: "title-pages" },
  {
    type: "collapse", name: "Notifications", key: "notifications",
    route: "/OrganizationOverview",
    component: (
        <ProtectedRoute>
          <OrganizationOverview/>
        </ProtectedRoute>
    ),
    icon: <i className="material-icons">notifications</i>, noCollapse: true,
  },
  {
    type: "collapse", name: "Limits", key: "limits",
    route: "/OrganizationOverview",
    component: (
        <ProtectedRoute>
          <OrganizationOverview/>
        </ProtectedRoute>
    ),
    icon: <LineAxisIcon />, noCollapse: true,
  },
  { type: "divider", key: "divider-1" },
  { type: "title", title: "ACCOUNT", key: "title-account" },
  {
    type: "collapse", name: "Users", key: "users",
    route: "/OrganizationUsers",
    component: (
        <ProtectedRoute>
          <OrganizationUsers />
        </ProtectedRoute>
    ),
    icon: <i className="material-icons">group</i>, noCollapse: true,
  },

  {
    type: "collapse", name: "Billing", key: "billing",
    route: "/Billing",
    component: (
        <ProtectedRoute>
          <Billing_dashboard/>
        </ProtectedRoute>
    ),
    icon: <i className="material-icons">payment</i>, noCollapse: true,
  },

];

export default routes;


